var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-system-bar',{staticClass:"px-4",attrs:{"app":"","color":"#f5f5f5"}},[_vm._v(" Mitarbeiter@Services ")])}
var staticRenderFns = []

export { render, staticRenderFns }